import {Component, Input, OnInit} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, FormArray,Validators} from '@angular/forms';
import {SpinnerService} from '../../shared/services/spinner.service';
import {ToastNotificationService} from '../../shared/services/toast-notify.service';
import {Branch} from '../../models/branch.model';
import { environment } from 'src/environments/environment';
import { Tenant } from 'src/app/models/tenant.model';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-navbar-admin',
  templateUrl: './subscription.component.html',
  styleUrls: ['./navbar-admin.component.scss'],  
})
export class SubscriptionComponent implements OnInit {

  @Input() tenantDetail: Tenant;
  @Input() modalRef: NgbModalRef;
  
  dateTimeFormat: string;
  startDate: any; endDate: any;
  countryList: any[];

  constructor(private formBuilder: FormBuilder,
                  private route: ActivatedRoute,
                  private router: Router,
                  private spinnerService: SpinnerService,
                  private toastNotifyService: ToastNotificationService,
              ) {
    }
  
    ngOnInit() {      
      console.log('****ngOnInit- PopupTestComponent: ');
      this.countryList = environment.countryList;
      this.dateTimeFormat = environment.dtOnlyFormatDefault
      console.log('tenantDetail>>>>>>>>>>>>',JSON.stringify(this.tenantDetail))
      this.startDate = formatDate(this.tenantDetail.subscrStart, 'yyyy-MM-dd', 'en-IN');
      this.endDate = formatDate(this.tenantDetail.subscrEnd, 'yyyy-MM-dd', 'en-IN');
      
    }

    /** Close modal */
    close() {
      console.log('****close edit-modal*****');
      this.modalRef.close();
    }
    /** Dismiss dialog */
    cancel() {
      console.log('****cancel-dismiss modal');
      this.modalRef.dismiss();
    }
}
